import React from 'react'

const About = () => {
  return (
    <div className='about'>
        <h1>About</h1>
        <h4>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptatum perferendis nemo minima accusamus ipsum ea minus reprehenderit atque temporibus harum alias ratione qui provident, dicta ipsam eveniet aut facilis at tempora quidem animi tempore error. Ipsam provident excepturi nobis. Voluptates ullam commodi illo consequatur, tempore nesciunt maiores tenetur eius cum!</h4>
    </div>
  )
}

export default About